import { Component, OnInit, OnDestroy, Inject, ViewChild } from '@angular/core';
import { Store, Action } from '@ngrx/store';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { MatDialogRef } from "@angular/material";
import { Actions } from '@ngrx/effects';
import { Subscription } from 'rxjs';
import { MAT_DIALOG_DATA } from '@angular/material';
import * as actions from '../../pillar/dashboard/store/actions';
import { ModuleConfiguration } from "../vocabulary.module.config";
import * as dashboardActions from '../../pillar/dashboard/store/actions';
import * as fromStore from '../store/reducers';
import * as vocabularyActions from '../store/actions';
import { DeleteConceptVersionModel } from '../models/DeleteConceptVersionModel';
import { ACTION_ERROR, ActionError } from '../../pillar/common/actions/ActionError';
import { AlertsComponent } from '../../pillar/alerts/components/alerts.component';
import { ValueSetModel } from '../models/ValueSetModel';

@Component({
  selector: 'brd-delete-concept-version',
  templateUrl: './delete-concept-version.component.html',
  styleUrls: ['./delete-concept-version.component.scss']
})
export class DeleteConceptVersionComponent implements OnInit, OnDestroy {


  eventUnsubscribe: Subscription;
  destroyed$: Subject<boolean> = new Subject<boolean>();
  name: string;
  code: string;
  conceptVersionKey: string;
  codeSystemVersionKey: string;
  deleteActionIdentifier: string;
  @ViewChild(AlertsComponent)
  alerts: AlertsComponent;


  constructor(public dialogRef: MatDialogRef<DeleteConceptVersionModel>,
    private router: Router,
    private actions$: Actions,
    private store: Store<any>,
    @Inject(MAT_DIALOG_DATA) public data: DeleteConceptVersionModel) {
    this.name = data.name;
    this.code = data.code;
    this.conceptVersionKey = data.conceptVersionKey;
    this.codeSystemVersionKey = data.codeSystemVersionKey;
  }

  ngOnInit() {
    this.eventUnsubscribe = this.actions$.ofType(actions.deleteSuccessType<DeleteConceptVersionModel>(ModuleConfiguration.moduleName, DeleteConceptVersionModel))
      .subscribe((a: actions.DeleteSuccessAction<DeleteConceptVersionModel>) => {
        if (this.code) {
          this.store.dispatch(new vocabularyActions.GetConceptListAction(ModuleConfiguration.moduleName,
            ValueSetModel,
            {
              page: 0,
              pageSize: 20,
              key: this.code,
              version: this.codeSystemVersionKey,
            }));
        } else {
          this.router.navigateByUrl('vocabulary-dashboard/' + this.codeSystemVersionKey);
        }
        this.close();
      });

    this.actions$.ofType(ACTION_ERROR)
      .filter((a: ActionError) => this.deleteActionIdentifier && a.payload.action.identifier === this.deleteActionIdentifier)
      .takeUntil(this.destroyed$)
      .subscribe((p: ActionError) => {
        for (let error in p.payload.errors) {
          if (p.payload.errors.hasOwnProperty(error)) {
            this.alerts.addError(p.payload.errors[error]);
          }
        }
      });
  }

  ngOnDestroy(): void {
    if (this.eventUnsubscribe) {
      this.eventUnsubscribe.unsubscribe();
    }
  }

  delete() {
    var model = this.data;
    var deleteAction = new actions.DeleteAction(ModuleConfiguration.moduleName, DeleteConceptVersionModel, { model: model });
    this.deleteActionIdentifier = deleteAction.identifier;
    this.store.dispatch(deleteAction);
  }

  close() {
    this.dialogRef.close();
  }

}



// WEBPACK FOOTER //
// ./src/app/vocabulary/components/delete-concept-version.component.ts